import React from "react";


export function RowNames({ rowNames, totalRows = [] }) {
    if (!rowNames) {
        return <div>RowNames</div>
    } else if (Array.isArray(rowNames) && rowNames.length === 0) {
        return <div>RowNames</div>
    } else if (!Array.isArray(rowNames)) {
        return <div>RowNames</div>
    }

    return (
        <div className="report__row-names-column">
            <table>
                <thead>
                    <tr ><th >&nbsp;</th></tr>
                    <tr ><th >&nbsp;</th></tr>
                </thead>
                <tbody>
                    {rowNames.map((rowName, rowIndex) => {
                        return (
                            <tr key={rowIndex} className={totalRows.includes(rowIndex) ? 'celda-totales' : ''}>
                                <td>{rowName}</td>
                            </tr>
                        )
                    }
                    )}
                </tbody>
            </table>
        </div>
    );
}

export function MonthHeader({ month, monthIndex }) {
    return (
        <thead key={monthIndex}>
            <tr>
                {/* <th colSpan={3} className="report__month-header-th">{month}</th> */}
                <th colSpan={3} className="report__month-header-th">{monthIndex + 1}</th>
            </tr>
            <tr>
                <th >Kg Secos</th>
                <th >Costo Kg Secos</th>
                <th >Valor total</th>
            </tr>
        </thead>
    );
}
